var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<pkp-toggle-panel [(is-open)]=\"$ctrl.settings.informAboutAssignmentManager\" (on-confirm)=\"$ctrl.toggleSpecificTermsAndConditions($event)\">\n<div titlex>Notification about Assignment Manager</div>\n<div subtitle>\nIf enabled, user change messages contain information on whether the user is an assignment manager or not.\n</div>\n</pkp-toggle-panel>\n";
var id1="app/operator-settings-general/inform-about-assignment-manager-settings.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;